var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Header'),_c('div',{staticClass:"contentbox flex flex-grow"},[(_vm.token)?_c('Sidebar'):_vm._e(),_c('div',{staticClass:"main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }